import { TextInput } from '@soteria/design-system-ve';

import { ClearButton } from './ClearButton';
import * as styles from './UsernameInputCard.css';

interface UsernameInputCardProps {
  username: string;
  onUsernameChange: (username: string) => void;
  onClear: () => void;
  hasError?: boolean;
}

/**
 * Username Input Card - single-line input for username classification
 * Uses TextInput (not TextArea) for short identifier input
 */
export function UsernameInputCard({ username, onUsernameChange, onClear, hasError }: UsernameInputCardProps) {
  return (
    <div className={styles.usernameInputContainer}>
      <TextInput
        hasError={hasError}
        maxLength={500}
        placeholder="Enter or paste username to classify"
        type="text"
        value={username}
        onChange={onUsernameChange}
      />
      {username && <ClearButton ariaLabel="Clear username input" title="Clear username" onClick={onClear} />}
    </div>
  );
}
